import { render } from "./PricesSectionComponent.vue?vue&type=template&id=6891686d&ts=true"
import script from "./PricesSectionComponent.vue?vue&type=script&lang=ts"
export * from "./PricesSectionComponent.vue?vue&type=script&lang=ts"

import "@/assets/css/style.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__